module.exports = __webpack_public_path__ + "media/assets/images/blog/girl_couch-small-eb6a752ea6360891ce5ed82a1998893d.jpeg";